import React, { useEffect, useState } from 'react'

import { Backdrop, Dialog, Fade } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import { useAppSelector } from 'redux/hooks'
import { themeStyles } from 'themes'

import AccountStatusChangedForm from './AccountStatusChangedForm-component'

const AccountStatusChangedModal = ({ classes }) => {
    const [open, setOpen] = useState(false)
    const { currentUser } = useAppSelector(state => state.user)

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        !!currentUser?.refreshBrowser && setOpen(true)
    }, [currentUser?.refreshBrowser])

    return (
        <Dialog
            className={classes.modal}
            open={open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            classes={{ paper: classes.paperDialogWidth, container: classes.MuiDialogContainer }}
        >
            <Fade in={open}>
                <div className={classes.paperDialog}>
                    <AccountStatusChangedForm handleClose={handleClose} />
                </div>
            </Fade>
        </Dialog>
    )
}

export default withStyles(themeStyles.useModalStyles)(AccountStatusChangedModal)
